<script setup>
import { utils } from '@shop/frontend/web/js/utils';
import { ref } from 'vue';
import { translator } from '@shop/frontend/web/js/services/TranslatorService';

translator.getLanguages();

const isCookieNotificationShow = ref(!utils.getCookie('isCookieAccepted'));

function closeCookieModal() {
  utils.setCookie('isCookieAccepted', 'true', { expires: 30 * 24 * 60 * 60, path: '/' });
  isCookieNotificationShow.value = false;
}
</script>

<template>
  <transition name="slide-out-bottom">
    <div v-if="isCookieNotificationShow" class="cookie-dialog">
      <div class="cookie-dialog__wrapper">
        <svg class="icon cookie-dialog__cookie-icon">
          <use xlink:href="#cookies" />
        </svg>
        <p class="cookie-dialog__text">
          {{ translator.t('main', 'By using this website, you consent to the use of cookies that help us make it more convenient for you') }}
        </p>
        <button class="cookie-dialog__btn btn" @click="closeCookieModal">
          Хорошо
        </button>
        <button class="cookie-dialog__close" @click="isCookieNotificationShow = false">
          <svg class="icon cookie-dialog__close-icon">
            <use xlink:href="#close" />
          </svg>
        </button>
      </div>
    </div>
  </transition>
</template>

<style lang="scss">
@import "@shop/../frontend/web/src/styles/utils/variables.scss";

.cookie-dialog {
  position: fixed;
  display: flex;
  justify-content: center;
  padding: 10px;
  right: 0;
  bottom: 30px;
  left: 0;
  z-index: 9999;

  &__wrapper {
    position: relative;
    display: flex;
    align-items: center;
    gap: 16px;
    padding: 26px 40px;
    background-color: $cookie-background;
    border-radius: $cookie-border-radius;
    box-shadow: 0px 2px 10.4px 0px #D4D4D4;
  }

  &__cookie-icon {
    width: 56px;
    height: 40px;
  }

  &__btn {
    padding: 9px 22px;
    font-size: 14px;
    font-weight: 500;
    background-color: $cookie-primary-color;
  }

  &__close {
    position: absolute;
    top: 2px;
    right: 7px;
    padding: 4px;
    color: $cookie-primary-color;
    cursor: pointer;
    background: none;
    border: 0;
  }

  &__close-icon {
    width: 14px;
    height: 14px;
    color: $cookie-primary-color;
  }

  &__text {
    margin: 0;
    max-width: 448px;
    font-weight: 400;
    font-size: 14px;
    line-height: 18px;
  }

  @media (max-width: $screen-xs) {
    bottom: 0;
    padding: 16px;

    &__wrapper {
      padding: 16px 12px;
      flex-direction: column;
    }

    &__text {
      max-width: none;
    }
  }
}

.left-cookie {
  fill: $cookie-left-color;
}

.right-cookie {
  fill: $cookie-right-color;
}
</style>
